import React from "react";

export default function SectionHeading({ eyebrow, title, intro, center = false, className = "" }) {
  return (
    <div className={`${center ? "text-center mx-auto" : ""} max-w-2xl ${className}`}>
      {eyebrow && (
        <p className={`eyebrow ${center ? "eyebrow--center" : ""} mb-4`}>{eyebrow}</p>
      )}
      <h2 className="font-display font-semibold text-3xl sm:text-4xl lg:text-5xl leading-[1.08] text-ink">
        {title}
      </h2>
      {intro && <p className="text-bark text-lg leading-7 mt-5">{intro}</p>}
    </div>
  );
}
